import { useEffect } from 'react';

// Cookiebot loads asynchronously and owns the widget DOM.
export const observeCookiebotLauncher = () => {
  let widget;
  let toggle;
  const onToggle = (event) => {
    event.preventDefault();
    event.stopImmediatePropagation();
    const expanded = toggle.getAttribute('aria-expanded') !== 'true';
    widget.setAttribute('data-launcher-expanded', String(expanded));
    toggle.setAttribute('aria-expanded', String(expanded));
    toggle.setAttribute('aria-label', expanded ? 'Hide cookie settings button' : 'Show cookie settings button');
  };
  const attach = () => {
    const nextWidget = document.getElementById('CookiebotWidget');
    if (nextWidget === widget && (!widget || widget.contains(toggle))) return;
    toggle?.removeEventListener('click', onToggle);
    toggle?.remove();
    widget = nextWidget;
    if (!widget) return;

    toggle = document.createElement('button');
    toggle.type = 'button';
    toggle.className = 'cookiebot-launcher-toggle';
    toggle.setAttribute('aria-label', 'Show cookie settings button');
    toggle.setAttribute('aria-expanded', 'false');
    widget.setAttribute('data-launcher-expanded', 'false');
    toggle.addEventListener('click', onToggle);
    widget.appendChild(toggle);
  };
  const observer = new MutationObserver(attach);
  observer.observe(document.body, { childList: true, subtree: true });
  attach();
  return () => {
    observer.disconnect();
    toggle?.removeEventListener('click', onToggle);
    toggle?.remove();
    widget?.removeAttribute('data-launcher-expanded');
  };
};

export const useCookiebotLauncher = () => useEffect(observeCookiebotLauncher, []);
